import { RouteRecordRaw } from 'vue-router'
import marketingModules from './marketing-module'

const unifiedPage = () => import('@/modules/Mfa/UnifiedPage.vue')

export const serviceDeskRoutes: RouteRecordRaw[] = [
  {
    path: "integrations",
    name: "Integrations",
    children: [
        {
            path: "",
            name: "Integration_index",
            meta: {
                module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
        },
        {
            path: "shopify",
            name: "Shopify_index",
            meta: {
                module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
        },
        {
            path: "neto",
            name: "Neto_index",
            meta: {
                module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
        },
        {
            path: "retail_express",
            name: "Retail_express_index",
            meta: {
                module: marketingModules.marketingLegacy.defaultLayoutPage,
            },
            component: unifiedPage,
        }
    ],
}
]
